import { useNavigate } from 'react-router-dom'
import Pagination from '../_components/pagination'
import { BoardListProps, fieldNames, TInput } from '../boardItem'
import { InquiryBoardTable } from './inquiryBoardTable'
import { BoardSearch } from '../_components/boardSearch'
import '../boardWeb.css'
import { useResponsive } from '@/hooks/useResponsive'
import { InquiryBoardTableMobile } from './InquiryBoardTableMobile'
import { BoardSearchMobile } from '../_components/boardSearchMobile'

export const InquiryBoardList: React.FC<BoardListProps> = ({
  srchData,
  setSrchData,
  setPage,
  boardList,
  pageCnt,
  getBoardList,
  boardSrchData,
}) => {
  const navigate = useNavigate()
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setSrchData((prev) => ({ ...prev, [name]: value }))
  }

  //글상세보기
  const handleDetailView = (nttSn: number) => {
    navigate(`/inquiry/detail?nttSn=${nttSn}`, { state: boardSrchData })
  }

  // 검색 버튼 클릭 시 또는 Enter 키 입력 시 getBoardList 실행
  const handleSearchSubmit = () => {
    getBoardList(1)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getBoardList(1)
    }
  }

  return (
    <>
      {!isMobile ? (
        <InquiryBoardTable
          boardList={boardList}
          fieldNames={fieldNames}
          handleDetailView={handleDetailView}
        />
      ) : (
        <InquiryBoardTableMobile
          boardList={boardList}
          fieldNames={fieldNames}
          handleDetailView={handleDetailView}
        />
      )}

      {!isMobile ? (
        <BoardSearch
          handleSearch={handleSearch}
          handleSearchSubmit={handleSearchSubmit}
          handleKeyDown={handleKeyDown}
          srchData={srchData}
        />
      ) : (
        <BoardSearchMobile
          handleSearch={handleSearch}
          handleSearchSubmit={handleSearchSubmit}
          handleKeyDown={handleKeyDown}
          srchData={srchData}
        />
      )}

      {pageCnt > 0 && (
        <Pagination
          totalCount={pageCnt}
          onPageChange={handlePageChange}
          paramPage={boardSrchData?.page || 1}
        />
      )}
    </>
  )
}
